import React, { useState, useRef, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
    Task,
    IconSignMinus,
    Button,
    InputSelect,
} from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import { showAlert } from '../../../common/Alert/util'
import useSendReports from './Model/useSendReports'

const UploadExcelReports = () => {
    //TODO: Al seleccionar el template, que liste las llaves (nombres de las columnas) que se necesitan
    const { translate } = useTranslation()
    const dispatch = useDispatch()
    const maxNumOfFiles = 1
    const maxSize = process.env.MAX_SIZE || process.env.REACT_APP_MAX_SIZE || 300 // Poner la cantidad máxima de mb
    const byteInMb = 1048576 // cuantos bytes son 1 mb
    const [showFilesToUpload, setShowFilesToUpload] = useState(true)
    const [loadingFiles, setLoadingFiles] = useState(false)
    const [filesUploadedByUser, setFilesUploadedByUser] = useState([])
    const [template, setTemplate] = useState(null)

    const options = [
        {
            id: 'ap-student-roster',
            name: 'Student Roster'
        },
        {
            id: 'ap-progress-report',
            name: 'Ap Progress Report'
        }]
    //eslint-disable-next-line
    const [sendReports, { loading, error }] = useSendReports(
        (res) => console.log('Success:', res),
        (err) => console.error('Error:', err)
    );

    const dropArea = useRef(null)

    const dragSpan = useRef(null)
    // Función que maneja los cambios en el Drag and Drop de los files
    const handleFileChange = (e) => {
        // If user drop File on DropArea
        dropArea.current.classList.remove('active')
        // dragImage.current.style.visibility = 'hidden'
        dragSpan.current.style.visibility = 'visible'
        let fullSize = 0
        if (!e.target.files) return
        if (e.target.files?.length > maxNumOfFiles) {
            showAlert(
                {
                    text: 'Too much files, please select only one file',
                    status: 'error',
                },
                dispatch,
            )
        }


        if (e?.target?.files) {
            fullSize = Array.from(e?.target?.files).reduce((fullSize, file) => {
                return fullSize + file.size
            }, 0)
        }

        if (fullSize > maxSize * byteInMb) {
            showAlert(
                {
                    text: `Max size error  ${maxSize} mb`,
                    status: 'error',
                },
                dispatch,
            )
        }

        setFilesUploadedByUser([e?.target?.files])

        if (showFilesToUpload === false) setShowFilesToUpload(true)

        setLoadingFiles(!loadingFiles)
    }

    // Función para borrar un archivo del array de archivos que se va a subir
    const removeFromListFunction = (itemRemove) => {
        let removed = filesUploadedByUser.filter(f => f.name !== itemRemove.name)
        setFilesUploadedByUser(removed)
    }

    const handleSendReports = () => {
        if (filesUploadedByUser.length === 0) {
            showAlert(
                { text: 'Please upload a file first', status: 'error' },
                dispatch
            );
            return;
        }
        if (!template) {
            showAlert(
                { text: 'Please select a template first', status: 'error'},
                dispatch
            );
            return;
        }
        const file = filesUploadedByUser[0][0]; // Tomamos el primer archivo
        sendReports({ variables: { file, template } });
    };

    useEffect(() => {
        if (dropArea && dropArea.current) {
            // If user Drag File Over DropArea
            dropArea.current.addEventListener('dragover', (event) => {
                event.preventDefault() // preventing from default behaviour
                dropArea.current.classList.add('active')
                // dragImage.current.style.visibility = 'visible'
                dragSpan.current.style.visibility = 'hidden'
            })

            // If user leave dragged File from DropArea
            dropArea.current.addEventListener('dragleave', () => {
                dropArea.current.classList.remove('active')
                // dragImage.current.style.visibility = 'hidden'
                dragSpan.current.style.visibility = 'visible'
            })
        }
    }, [])

    return (
        <div className='mt-4 mb-1'>
            <div className='d-flex flex-column align-items-start mb-3'>
                <span className='h4'> Upload Excel to send reports</span>
            </div>
            <div id='drop-zone'
                ref={dropArea}
                className='file-select-tasks mb-4 d-flex flex-column align-items-center justify-content-center'
                style={{
                    borderColor: '#DCE1E7',
                    // width: "450px", 
                    height: "350px",
                    textAlign: "center",
                }}
            >
                <span
                    className="d-flex flex-column align-items-center justify-content-center"
                    style={{
                        visibility: "visible",
                        textAlign: "center",
                        display: "inline-block",
                        width: "150px",
                        height: "150px",
                        padding: "10px",
                        borderRadius: "5px",
                    }}
                    id="dragSpan"
                    ref={dragSpan}
                >
                    <span className="cursor-pointer">
                        <u>Browse files</u>
                    </span>
                </span>

                <input
                    className='d-flex justify-content-center py-0 mb-4 input-drop'
                    type='file'
                    style={{ backgroundColor: 'transparent' }}
                    id='input'
                    name='input'
                    onChange={handleFileChange}
                    multiple
                />
            </div>

            <div
                id='files-info'
                className='d-flex flex-column mb-4'
                style={{
                    display: showFilesToUpload ? 'block' : 'none',
                }}
            >
                {filesUploadedByUser?.length > 0 && (
                    <span className='h4 mb-1'>
                        {' '}
                        {translate('counseling.title2')}{' '}
                    </span>
                )}
                {filesUploadedByUser?.length > 0 &&
                    filesUploadedByUser?.map((x, index) => (
                        <div className='d-flex flex-row align-items-center justify-content-between'>
                            <Task
                                noIcon
                                taskClassName='my-1'
                                labelLeft={
                                    <div>
                                        <span style={{ lineHeight: '1.6', color: '#4a6270' }}>
                                            {x[0].name}
                                        </span>
                                    </div>
                                }
                                labelRight={
                                    <IconSignMinus
                                        color={'#778699'}
                                        size={14}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => removeFromListFunction(x)}
                                    />
                                }
                            />
                        </div>
                    ))}
            </div>
            <InputSelect
                isMulti={false}
                name={`selectTemplate`}
                // isLoading={loading || loadUpcoming}
                InputClassName='my-3 col-5'
                menuPlacement={'top'}
                value={template}
                options={
                    options.map((opt) => {
                        return {
                            value: opt.id,
                            name: opt.name,
                            label:
                                <div className="w-100 d-flex flex-row align-items-center justify-content-start">
                                    <div className='d-flex flex-row'>
                                        <span className='align-self-center'>{opt.name}</span>
                                    </div>
                                </div>
                        }
                    })
                }
                onChange={(e) => {
                    console.log(e)
                    setTemplate(e)
                }}
            />

            <Button
                color='primary'
                activity={loading}
                className='col-5'
                label={'Send Reports'}
                onClick={handleSendReports}
                style={{ borderRadius: '16px' }}
            />


        </div>
    )
}

export default UploadExcelReports
